module.exports = __webpack_public_path__ + "static/fonts/WebComponentsIcons.b45bf89.eot";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/glyphs/WebComponentsIcons.eot?gedxeo
// module id = 1627
// module chunks = 28